'use client';

import React, { useState, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { AdminLayout } from '../layouts/AdminLayout';
import { ADMIN_SECTION } from '../../constants/sections';
import type { AdminSectionId } from '../../constants/sections';
import DashboardPage from '../sections/DashboardPage';
import UsersPage from '../sections/UsersPage';
import ServicesPage from '../sections/ServicesPage';
import RemindersPage from '../sections/RemindersPage';
import PlansPage from '../sections/PlansPage';
import ReminderSettingsPage from '../sections/ReminderSettingsPage';
import DespesasPage from '../sections/DespesasPage';
import TermosDeUsoAdminPage from '../sections/TermosDeUsoAdminPage';
import PoliticaPrivacidadeAdminPage from '../sections/PoliticaPrivacidadeAdminPage';

/** Nome/email do admin (MVP: mock; depois vir de auth/role) */
const MOCK_ADMIN_DISPLAY_NAME = 'admin@retornaar.com';

export default function AdminPage() {
  const navigate = useNavigate();
  const [currentSection, setCurrentSection] = useState<AdminSectionId>(ADMIN_SECTION.DASHBOARD);
  const [isLoggingOut, setIsLoggingOut] = useState(false);

  const handleLogout = useCallback(async () => {
    setIsLoggingOut(true);
    try {
      // MVP: apenas redireciona; depois integrar com auth (signOut + redirect)
      await new Promise((r) => setTimeout(r, 500));
      navigate('/login', { replace: true });
    } finally {
      setIsLoggingOut(false);
    }
  }, [navigate]);

  const renderSection = () => {
    switch (currentSection) {
      case ADMIN_SECTION.DASHBOARD:
        return <DashboardPage />;
      case ADMIN_SECTION.RELATORIOS:
        return <DashboardPage />;
      case ADMIN_SECTION.USUARIOS:
        return <UsersPage />;
      case ADMIN_SECTION.SERVICOS:
        return <ServicesPage />;
      case ADMIN_SECTION.LEMBRETES:
        return <RemindersPage />;
      case ADMIN_SECTION.PLANOS:
        return <PlansPage />;
      case ADMIN_SECTION.DESPESAS:
        return <DespesasPage />;
      case ADMIN_SECTION.PERIODIZACAO_LEMBRETES:
        return <ReminderSettingsPage />;
      case ADMIN_SECTION.TERMOS_USO:
        return <TermosDeUsoAdminPage editorDisplayName={MOCK_ADMIN_DISPLAY_NAME} />;
      case ADMIN_SECTION.POLITICA_PRIVACIDADE:
        return <PoliticaPrivacidadeAdminPage editorDisplayName={MOCK_ADMIN_DISPLAY_NAME} />;
      default:
        return <DashboardPage />;
    }
  };

  return (
    <AdminLayout
      currentSection={currentSection}
      onSectionChange={setCurrentSection}
      onLogout={handleLogout}
      isLoggingOut={isLoggingOut}
      adminDisplayName={MOCK_ADMIN_DISPLAY_NAME}
    >
      {renderSection()}
    </AdminLayout>
  );
}
